import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ExtendedHammerRatingDetails,
  InstallationTypeSubtypesClaimed,
  ReputationScoreWithTier,
} from '../../../../core/installer-profile';
import { ProductInstallationSubtypesClaimed } from '../../../../domains/training/product-installation-subtypes-claimed/product-installation-subtypes-claimed.model';
import { ProductInstallationType } from '../../../../domains/training/product-installation-types/product-installation-types.model';
import { Installer, isInstallerLead } from '../../../../domains/users';
import { KudosReason } from '../../../../domains/users/kudos-reason/kudos-reason.model';

@Component({
  selector: 'gc-overview-area',
  templateUrl: './overview-area.component.html',
  styleUrls: ['./overview-area.component.scss'],
})
export class OverviewAreaComponent {
  @Input() kudosReason?: KudosReason;
  @Input() hammerRatingsDetails!: ExtendedHammerRatingDetails[];
  @Input() productInstallationSubtypes!: InstallationTypeSubtypesClaimed[];
  @Input() canEditProfile!: boolean;
  @Input() installer!: Installer;
  @Input() reputationScore?: ReputationScoreWithTier;

  @Output() subtypeAdded = new EventEmitter<ProductInstallationType>();
  @Output() subtypeRemoved = new EventEmitter<ProductInstallationSubtypesClaimed>();

  get hasCommercialWorkPercentage(): boolean {
    return (
      isInstallerLead(this.installer) &&
      this.installer.commercialWorkPercentage !== null &&
      this.installer.commercialWorkPercentage !== undefined
    );
  }

  get commercialWorkPercentage(): number {
    return isInstallerLead(this.installer) ? this.installer.commercialWorkPercentage ?? 0 : 0;
  }
}
